import { Component, Input, OnInit } from '@angular/core';
import { BusinessAccountsService } from '../business-accounts.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-multi-currency',
  templateUrl: './multi-currency.component.html',
  styleUrls: ['./multi-currency.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
})
export class MultiCurrencyComponent implements OnInit {
  @Input() queryParams: any;
  multiCuurencyPanelData:any;
  videoUrl: string = '';
  videoThumbnail: string = '';

  constructor(private businessAccountsService: BusinessAccountsService) {
    this.subscriptions = [];
  }

  subscriptions: Subscription[];
  ngOnInit(): void {
    this.businessAccountsService.multiCurrency$.subscribe(data => {
      if (data != null) {
        this.multiCuurencyPanelData = {
          cards: data?.component1,
        };
        this.videoUrl = `https:${this.multiCuurencyPanelData?.videoCard?.fields?.imageicon?.fields?.file?.url}`;
        this.videoThumbnail = `https:${this.multiCuurencyPanelData?.videoCard?.fields?.linkedElements[0]?.fields?.iconImage?.fields?.file?.url}`;
      }
    });
  }

  isPlaying = false;

  playVideo(videoPlayer: HTMLVideoElement) {
    videoPlayer.play();
    this.isPlaying = true;
  }

  onPlay() {
    this.isPlaying = true;
  }

  onPause() {
    this.isPlaying = false;
  }

  navigateToVertoFX(link:any) {
    location.pathname = link;
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }
}
